import { render, staticRenderFns } from "./Control_Procesos.vue?vue&type=template&id=3833253c&scoped=true&"
import script from "./Control_Procesos.vue?vue&type=script&lang=js&"
export * from "./Control_Procesos.vue?vue&type=script&lang=js&"
import style0 from "./Control_Procesos.vue?vue&type=style&index=0&id=3833253c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833253c",
  null
  
)

export default component.exports